import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import Paper from '@material-ui/core/Paper';
import PayIcon from '@material-ui/icons/AddShoppingCart';
import Button from '@material-ui/core/Button';
import { registerPayment } from '../Networking/APIClient';
import ConfirmPurchaseDialog from '../Components/ConfirmPurchaseDialog';
import LocalControlDialog from '../Components/LocalControlDialog';
import ConfirmDialog from './ConfirmDialog';

let t;
let self;

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: '10px',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

class SubscriptionTypes extends React.Component {
    constructor(props) {
        super(props);
        self = this;
        t = props.t;
        this.state = {
            credentials: props.credentials,
            gateways: props.gateways,
            expanded: null,
            confirmPurchaseDialogOpen: false,
            selectedSubscription: {
                value_code: '',
                subscription_type: '',
                buy_description_short: '',
                fee: '',
                vipps_agreement_id: '',
                valid_to_date: '',
            },
            gateway: null,
            localControlDialogOpen: false,
        }
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    onChooseClicked(value_code, subscription_type, buy_description_short, valid_to_date, fee, vipps_agreement_id, best_effort_name, e) {
        if (e != null) {
            e.preventDefault();
        }
        // If the user is not fully registered, they cannot use Local Control. In this case, we show a dialog with information.
        if (subscription_type === 'LocalControl' && (!this.props.customer.customer_is_registered || !this.props.customer.customer_is_registered_full)) {
            self.setState({
                selectedSubscription: {
                    value_code: value_code,
                    subscription_type: subscription_type,
                    buy_description_short: buy_description_short,
                    fee: fee,
                    vipps_agreement_id: vipps_agreement_id,
                    best_effort_name: best_effort_name,
                    valid_to_date: valid_to_date,
                },
                localControlDialogOpen: true
            });
        } else {
            self.setState({
                selectedSubscription: {
                    value_code: value_code,
                    subscription_type: subscription_type,
                    buy_description_short: buy_description_short,
                    fee: fee,
                    vipps_agreement_id: vipps_agreement_id,
                    best_effort_name: best_effort_name,
                    valid_to_date: valid_to_date,
                },
                confirmPurchaseDialogOpen: true
            });
        }
    }

    onChangeSubscriptionSelected(value_code, subscription_type, buy_description_short, valid_to_date, e) {
        e.preventDefault();

        const selectedSubscription = {
            value_code,
            subscription_type,
            buy_description_short,
            valid_to_date
        };

        const currentSubscriptionType = this.props.gateway.subscription_type;

        self.props.updatePageWithProps('change_subscription', {
            selectedSubscription,
            currentSubscriptionType
        });
    }

    onPaymentTypeSelected(paymentType, e) {
        e.preventDefault();

        const selectedSubscription = self.state.selectedSubscription;

        const onNetsPaymentOk = function onOk(payment_completion_url) {
            // This loading bar was hiding too quick for its own good. Caused confusion in the payment flow.
            // Retired from service Jan 20 2023
            // self.props.setLoading(false);
            window.open(payment_completion_url, '_self');
        };

        const onNetsPaymentError = function onError() {
            console.log("Purchase failed");
            self.props.setLoading(false);
        };

        switch (paymentType) {
            case 'vipps':
                registerPayment(self.props.language, selectedSubscription.value_code, self.props.automaticLogin, selectedSubscription.subscription_type, self.props.hasMultipleGateways, self.state.credentials, onNetsPaymentOk, onNetsPaymentError, true);
                break;
            case 'nets':
                registerPayment(self.props.language, selectedSubscription.value_code, self.props.automaticLogin, selectedSubscription.subscription_type, self.props.hasMultipleGateways, self.state.credentials, onNetsPaymentOk, onNetsPaymentError, false);
                break;
            default:
                console.log("No payment type selected.");
                break;
        }

        // Hide dialog and show a loading bar while waiting for response.
        self.toggleConfirmPurchaseDialog();
        self.props.setLoading(true);
    }

    // Method for sending customer "directly" to Confirm Purchase Dialog with the same subscription they already have
    // i.e. a renewal of their current subscription
    sendToPurchaseDialog(gateway, e) {

        // If any loading screen is showing, hide it
        self.props.setLoading(false);

        // Map the available subscription types for the gateway
        // If the current subscription type for the gateway is found, use that type's buy_description_short and fee
        // as parameters for onChooseClicked
        gateway.buy_descriptions.map(buy_description => {
            switch (buy_description.subscription_type) {
                case gateway.subscription_type:
                    gateway.buy_description_short = buy_description.buy_description_short;
                    gateway.fee = buy_description.fee;
                    gateway.valid_to_date = buy_description.valid_to_date;
                    break;
            }
        });
        // If current subscription type is not found among gateway's buy_descriptions, we don't have
        // all the necessary info to show the customer Confirm Purchase Dialog, so we don't call onChooseClicked
        if (gateway.fee != null && gateway.buy_description_short != null) {
            this.onChooseClicked(gateway.value_code, gateway.subscription_type, gateway.buy_description_short, gateway.valid_to_date, gateway.fee, gateway.vipps_agreement_id, gateway.best_effort_name, e);
            // If customer decides to not go through with the payment right away, don't nag them with the dialog again
            self.props.setShouldRenewSubscription(false);
        }
    }

    getFullBuyDescriptionForGateway(gateway) {
        const { classes } = this.props;
        const { expanded } = this.state;

        const filteredBuyDescriptions = gateway.buy_descriptions.filter(
            (buy_description) => buy_description.subscription_type === gateway.subscription_type || !["Winter", "Monthly"].includes(buy_description.subscription_type)
        );

        // Todo: merge with below method
        const buyDescription = filteredBuyDescriptions.map((buy_description) =>
            <div key={buy_description.subscription_type}>
                <div className={classes.root}>
                    <ExpansionPanel expanded={expanded === 'panel_' + buy_description.subscription_type} onChange={this.handleChange('panel_' + buy_description.subscription_type)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading}>{t(buy_description.subscription_type)}</Typography>
                            <Typography className={classes.secondaryHeading}>{buy_description.buy_description_short}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {t('details')}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {buy_description.features}
                            </Typography>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {t('valid_to')}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {buy_description.valid_to_date}
                            </Typography>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {t('price')}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {buy_description.fee}
                            </Typography>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {/*
                                    Empty. Just for the button to place correctly
                                */}
                            </Typography>
                            <Typography className={classes.secondaryHeading} style={buttonStyle}>
                                {!buy_description.is_change ? <Button
                                    onClick={e => this.onChooseClicked(gateway.value_code, buy_description.subscription_type, buy_description.buy_description_short, buy_description.valid_to_date, buy_description.fee, gateway.vipps_agreement_id, gateway.best_effort_name, e)}
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary">
                                    <PayIcon style={buttonIconStyle} />
                                    {t('choose')}
                                </Button > :
                                    <Button
                                        onClick={e => this.onChangeSubscriptionSelected(gateway.value_code, buy_description.subscription_type, buy_description.buy_description_short, buy_description.valid_to_date, e)}
                                        style={buttonStyle}
                                        variant="contained"
                                        color="primary">
                                        <PayIcon style={buttonIconStyle} />
                                        {t('change')}
                                    </Button >}
                            </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </div>
            </div>);

        return buyDescription;
    }

    // Todo: merge with above method
    // NOT USED PER 02/25
    getDefaultBuyDescriptionForGateway(gateway) {
        const { classes } = this.props;
        const defaultExists = this.defaultExists(gateway);
        const buyDescription = gateway.buy_descriptions.map((buy_description) =>
            <div key={buy_description.subscription_type}>
                <div className={classes.root}>
                    {/*
                    This will only return buy description if default is set to true. This makes
                    sure we only return the default buy_description on the overview page
                    */}
                    {buy_description.default ? <ExpansionPanel defaultExpanded={true} onChange={this.handleChange('panel_' + buy_description.subscription_type)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography className={classes.heading}>{t(buy_description.subscription_type)}</Typography>
                            <Typography className={classes.secondaryHeading}>{buy_description.buy_description_short}</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {t('details')}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {buy_description.features}
                            </Typography>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {t('valid_to')}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {buy_description.valid_to_date}
                            </Typography>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {t('price')}
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                {buy_description.fee}
                            </Typography>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails>
                            <Typography className={classes.heading}>
                                {/*
                                    Empty. Just for the button to place correctly
                                */}
                            </Typography>
                            <Typography className={classes.secondaryHeading} style={buttonStyle}>
                                <Button
                                    onClick={e => this.onChooseClicked(gateway.value_code, buy_description.subscription_type, buy_description.buy_description_short, buy_description.valid_to_date, buy_description.fee, gateway.vipps_agreement_id, gateway.best_effort_name, e)}
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary">
                                    <PayIcon style={buttonIconStyle} />
                                    {t('choose')}
                                </Button >
                            </Typography>
                        </ExpansionPanelDetails>
                    </ExpansionPanel> : null}

                </div>
            </div>);

        const noBuyDescriptionExistsContent = <Typography variant="subheading">{t('subscription_no_action_required')}</Typography>;

        return (defaultExists ? buyDescription : noBuyDescriptionExistsContent);
    }

    // Todo: too many loops with this and above methods. Merge somehow
    defaultExists(gateway) {
        const buyDescriptions = gateway.buy_descriptions;
        const arrayLength = buyDescriptions.length;
        for (var i = 0; i < arrayLength; i++) {
            if (buyDescriptions[i].default != null) {
                return true;
            }
        }

        return false;
    }

    toggleConfirmPurchaseDialog() {
        self.setState((prevState) => ({
            confirmPurchaseDialogOpen: !prevState.confirmPurchaseDialogOpen
        }));
    }

    toggleLocalControlDialog() {
        self.setState((prevState) => ({
            localControlDialogOpen: !prevState.localControlDialogOpen
        }));
    }

    hideCompanyDialog = e => {
        e.preventDefault();
        this.setState({
            purchaseDialogOpen: false
        });
    }

    // When this component is fully loaded, check for state flags regarding if customer should be sent to Purchase Dialog
    // Only do this for registered customers, as trial customers need a different dialog
    componentDidMount() {
        { (this.props.shouldRenewSubscription && (this.props.customer.customer_is_registered || this.props.customer.customer_is_registered_full)) ? this.sendToPurchaseDialog(this.props.gateway, null) : null }
    }

    render() {
        const customer_is_registered_full = this.props.customer.customer_is_registered_full;
        const customer_is_registered = this.props.customer.customer_is_registered;
        const gateway = this.props.gateway;
        let dialog;

        if (this.state.confirmPurchaseDialogOpen && this.state.selectedSubscription.subscription_type === 'Company') {
            dialog = <ConfirmDialog
                titleText={t('company_subscription_information_title')}
                messageText={t('company_subscription_information_message')}
                buttonText={t('ok')}
                toggleDialog={this.toggleConfirmPurchaseDialog}
                onButtonClicked={this.toggleConfirmPurchaseDialog}
                open={this.state.confirmPurchaseDialogOpen}
            />;
        } else if (this.state.localControlDialogOpen) {
            dialog = <LocalControlDialog
                customer_is_registered={customer_is_registered}
                customer_is_registered_full={customer_is_registered_full}
                updatePage={this.props.updatePage}
                toggleDialog={this.toggleLocalControlDialog}
                open={this.state.localControlDialogOpen}
                t={this.props.t}
            />;
        } else if (this.state.confirmPurchaseDialogOpen && this.state.selectedSubscription.subscription_type !== 'Company') {
            dialog = <ConfirmPurchaseDialog
                automaticLogin={this.props.automaticLogin}
                language={this.props.language}
                setLoading={this.props.setLoading}
                onPaymentTypeSelected={this.onPaymentTypeSelected}
                t={t}
                selectedSubscription={this.state.selectedSubscription}
                toggleDialog={this.toggleConfirmPurchaseDialog}
                open={this.state.confirmPurchaseDialogOpen}
            />;
        } else {
            dialog = null;
        }

        return (
            <div>
                {dialog}
                <div key={gateway.bpapi_gateway_id}>
                    {this.getFullBuyDescriptionForGateway(gateway)}
                </div>
            </div>

        );
    }
}

SubscriptionTypes.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubscriptionTypes);

const buttonStyle = {
    width: '100%'
};

const buttonIconStyle = {
    paddingRight: 10,
};


// WEBPACK FOOTER //
// ./src/Components/SubscriptionTypes.js